export const abi = [
    {
        constant: false,
        inputs: [
            {
                name: '_pixelNumber',
                type: 'uint16'
            }
        ],
        name: 'deleteMessage',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: '_pixelNumber',
                type: 'uint16'
            },
            {
                name: '_message',
                type: 'string'
            }
        ],
        name: 'setMessage',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'numberOfPixels',
        outputs: [
            {
                name: '',
                type: 'uint16'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: 'beneficiary',
                type: 'address'
            },
            {
                name: '_pixelNumber',
                type: 'uint16'
            },
            {
                name: '_color',
                type: 'uint24'
            },
            {
                name: '_message',
                type: 'string'
            }
        ],
        name: 'buyPixel',
        outputs: [],
        payable: true,
        stateMutability: 'payable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: '_isMesssageEnabled',
                type: 'bool'
            }
        ],
        name: 'setMessageStatus',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'getColors',
        outputs: [
            {
                name: '',
                type: 'uint24[10000]'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: '_pixelNumber',
                type: 'uint16'
            },
            {
                name: '_color',
                type: 'uint24'
            }
        ],
        name: 'setColor',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: '_pixelNumber',
                type: 'uint16'
            },
            {
                name: '_owner',
                type: 'address'
            }
        ],
        name: 'setOwner',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'feeRate',
        outputs: [
            {
                name: '',
                type: 'uint256'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'width',
        outputs: [
            {
                name: '',
                type: 'uint16'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: '_pixelNumber',
                type: 'uint16'
            },
            {
                name: '_weiAmount',
                type: 'uint256'
            }
        ],
        name: 'setPrice',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: '_pixelNumber',
                type: 'uint16'
            },
            {
                name: '_isSale',
                type: 'bool'
            }
        ],
        name: 'setSaleState',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: true,
        inputs: [
            {
                name: '',
                type: 'uint256'
            }
        ],
        name: 'colors',
        outputs: [
            {
                name: '',
                type: 'uint24'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [
            {
                name: '_pixelNumber',
                type: 'uint16'
            }
        ],
        name: 'getPixel',
        outputs: [
            {
                name: '',
                type: 'address'
            },
            {
                name: '',
                type: 'string'
            },
            {
                name: '',
                type: 'uint256'
            },
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'isMessageEnabled',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor'
    },
    {
        payable: true,
        stateMutability: 'payable',
        type: 'fallback'
    }
]
